<template>
  <div class="contact-page">
    <v-overlay
      v-model="loading"
      persistent
      class="align-center justify-center"
      scroll-strategy="block"
    >
      <v-progress-circular
        color="primary"
        size="64"
        indeterminate
      ></v-progress-circular>
    </v-overlay>
    <v-row><h1 class="contact-title mb-4">Contact</h1></v-row>
    <v-row class="contact-container">
      <v-col class="contact-summary">
        <h2 class="mb-8">Feel free to reach me with any of these methods:</h2>
        <v-row class="contact-method">
          <v-icon class="contact-icon">mdi-email</v-icon>
          <a class="contact-info-email" href="mailto:mathias@motso.co"> mathias@motso.co</a>
        </v-row>
        <v-row class="contact-method">
          <v-icon class="contact-icon">mdi-phone</v-icon>
          <a class="contact-info-email" href="tel:+12246007165"> (224) 600-7165</a>
        </v-row>
      </v-col>
      <v-col class="contact-form">
        <v-form ref="form" v-model="valid" @submit.prevent="submitForm">
          <v-text-field v-model="email" label="Email Address" type="email" :rules="[rules.required, rules.email]"></v-text-field>
          <v-text-field v-model="subject" label="Subject" :rules="[rules.required]"></v-text-field>
          <div class="scroll-on-hover"><v-textarea v-model="body" label="Message" auto-grow :rules="[rules.required]"></v-textarea></div>
          <v-btn :disabled="!valid" color="#032855" type="submit" block class="mt-4">Submit</v-btn>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import emailjs from 'emailjs-com';
const SERVICE_ID = 'service_7irmerx';
const TEMPLATE_ID = 'template_4cgywwb';
const USER_ID = 'i8GPZ_qs-M3EXujHl';

export default {
    data() {
        return {
            valid: false,
            loading: false,
            email: '',
            subject: '',
            body: '',
            rules: {
              required: (value) => !!value || "Required.",
              email: (value) =>
              /.+@.+\..+/.test(value) || "Enter a valid email address.",
            },
        }
    },
    methods: {
      submitForm() {
        if (this.$refs.form.validate()) {

          this.loading = true;

          const templateParams = {
            from_email: this.email,
            subject: this.subject,
            message: this.body,
          };

          emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, USER_ID)
            .then(() => {
              alert('Message sent successfully!');
              this.email = '';
              this.subject = '';
              this.body = '';
            })
            .catch((error) => {
              console.error('EmailJS error:', error);
              alert('Failed to send message. Please try again later.');
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }
    },
    
}
</script>

<style scoped>
@import '~@mdi/font/css/materialdesignicons.css';
.contact-page {
  text-align: center;
  padding: 20px;
}
.contact-summary, .contact-form, .contact-title {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  padding: 15px;
  border-radius: 10px;
  border: 3px solid #ddaf52;
}
.contact-summary {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: clamp(14px, 1.6vw, 20px);
  margin-left: 2.5vw;
  margin-right: 1.25vw;
  align-items: center; 
  align-self: flex-start; 
  max-height: 60vh;
}
.contact-form {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-left: 1.25vw;
  margin-right: 2.5vw;
  max-height: 60vh;
}
.contact-title {
  font-size: clamp(5vh, 5.5vw, 6vh);
  margin-left: 2.5vw;
  text-align: left;
}
.contact-method {
  display: flex;
  align-items: center; 
  justify-content: center;
  gap: 12px; 
  margin-bottom: 10px; 
  font-size: clamp(20px, 2vw, 32px);
}
.contact-icon {
  color: #023e7b;
  font-size: clamp(20px, 2vw, 32px);
}
.contact-info-email{
  color: #023e7b;
  font-weight: normal;
  text-decoration: none;
}
.contact-info-email:hover{
  color: #f26525;
  font-weight: normal;
  transition: color 0.7s ease;
}
.scroll-on-hover {
  max-height: 60vh;
  overflow-y: hidden;
  overscroll-behavior: contain;
}
</style>